import AppService from "./app-service"
import objectToList from "@/utils/object-to-list"

const path = "employee-invoices"

export default class EmployeeInvoiceService extends AppService {

  constructor() {
    super({ path })
  }

  static get STATUS() {
    return {
      waiting: {
        id: "waiting",
        icon: "clock outline orange icon",
        label: '<i class="clock outline orange icon"></i> Aguardando aprovação',
        description: "Aguardando aprovação",
      },
      approved: { 
        id: "approved",
        icon: "clock blue icon",
        label: '<i class="clock blue icon"></i> Aguardando finalização',
        description: "Aguardando finalização",              
      },
      finished: { 
        id: "finished",
        icon: "check circle green icon",
        label: '<i class="check circle green icon"></i> Finalizado',
        description: "Finalizado",              
      },
    }
  }

  static getStatusList() {    
    return objectToList(EmployeeInvoiceService.STATUS)
  }

  static getFilterStatusList() {
    return [
      { id: "*", value: '<i class="asterisk icon"></i> Todos' },
      { id: "invoiced", value: '<i class="check blue icon"></i> Fechados' },
      { id: "uninvoiced", value: '<i class="clock orange icon"></i> Não fechados' },
    ]
  }

  getCertsByPaymentType(filter) {
    return this.http.post(`${path}/certs?by=paymentType`, filter) 
  }

  getCertsByCustomer(filter) {
    return this.http.post(`${path}/certs?by=customer`, filter) 
  }

  getUninvoicedEmployees(filter) {
    return this.http.post(`${path}/uninvoiced-employees`, filter) 
  }

  getEmployeeCerts(filter) {
    return this.http.post(`${path}/certs`, filter)
  }

  getEmployeeAnticipations(filter) {
    return this.http.post(`${path}/anticipations`, filter)
  }  

  filter(data) {
    return this.http.post(`${path}/filter`, data)
  }

  approve(id) {
    return this.http.post(`${path}/${id}/approve`)
  }

  disapprove(id) {
    return this.http.post(`${path}/${id}/disapprove`)
  }

  finish(id) {
    return this.http.post(`${path}/${id}/finish`)
  }

  undoFinish(id) {
    return this.http.post(`${path}/${id}/undo-finish`)
  }

  getLastInvoiceDate(userId) {
    return this.http.get(`${path}/${userId}/last-invoice-date`) 
  }

  hasInvoice(userId, date) {
    return this.http.post(`${path}/has-invoice`, { userId, date }).then((data) => data.hasInvoice)
  }
}